<div class="pr-96px pt-104px pr-3">
    <div class="warning-rectangle flex-display height-4rem">
        <div class="ptr-18">
          <img src="../../../assets/icons/warning-orange.svg" class="info-img" alt="Warning Icon">
        </div>
        <div class="ptb-18 infoWarning height-0 bold font-18" tabindex="0" [innerHTML]="title">
        </div>
      </div>
        <p>
            Exception ID: {{ExceptionID}} 
        </p>
     <p>
        Please contact <a href="{{supportUrl}}" target="_blank">FAF Support</a> with above Exception ID.
    </p>
    
    </div>